import {Directive, Input, OnInit, Output, TemplateRef, ViewContainerRef} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Hardware} from '../types/hardware';
import {Validators} from '@softline/ui-core';

class HardwareContext {
  form: UntypedFormGroup = new UntypedFormGroup({});
}

@Directive({
  selector: '[hardwareForm]',
  exportAs: 'hardwareForm'
})
export class HardwareFormDirective implements OnInit {

  private context = new HardwareContext();

  form = this.createForm();

  @Input()
  set hardwareForm(value: Partial<Hardware> | undefined) {
    this.form.reset(value);
  }

  @Input()
  set validation(value: boolean) {
    this.form = this.createForm(value);
  }

  @Output() valueChange = this.form.valueChanges;

  constructor(private templateRef: TemplateRef<HardwareContext>,
              private viewContainer: ViewContainerRef) {}

  static ngTemplateGuard_hardwareForm(
    dir: HardwareFormDirective,
    form: Partial<Hardware>
  ): form is Partial<Hardware> {
    return true;
  }

  // Make sure the template checker knows the type of the context with which the
  // template of this directive will be rendered
  static ngTemplateContextGuard(
    directive: HardwareFormDirective,
    context: unknown
  ): context is HardwareContext {
    return true;
  }

  ngOnInit() {
    this.context.form = this.form;
    this.viewContainer.createEmbeddedView(this.templateRef, { form: this.form });
  }

  private createValidatedFormControl<T = unknown>(
    { subject, message, initial  }: { subject: string, message: string, initial: T | null }
  ): UntypedFormControl {
    return new UntypedFormControl(initial, Validators.required({
      success: false,
      validation: {
        isValid: false,
        messages: [
          {
            message,
            type: 'error',
            subject
          }
        ]
      },
    }));
  }

  private createForm(validation = true): UntypedFormGroup {
    return new UntypedFormGroup({
      id: new UntypedFormControl(null),
      autoid: new UntypedFormControl(null),
      hostname: new UntypedFormControl(null),
      benutzer: new UntypedFormControl(null),
      passwort: new UntypedFormControl(null),
      hardwaretyp: !validation
        ? new  UntypedFormControl(null)
        : this.createValidatedFormControl({
            initial: null,
            message: 'Hardware-Typ muss angegeben werden!',
            subject: 'Eingabe notwendig'
          }),
      produkt: !validation
          ? new  UntypedFormControl(null)
          : this.createValidatedFormControl({
            initial: null,
            message: 'Produkt muss angegeben werden!',
            subject: 'Eingabe notwendig'
          }),
      hersteller: !validation
        ? new  UntypedFormControl(null)
        : this.createValidatedFormControl({
          initial: null,
          message: 'Hersteller muss angegeben werden!',
          subject: 'Eingabe notwendig'
        }),
      seriennummer: new UntypedFormControl(null),
      service_tag: new UntypedFormControl(null),
      express_service_tag: new UntypedFormControl(null),
      domaene: new UntypedFormControl(null),
      arbeitsgruppe: new UntypedFormControl(null),
      mac_adresse: new UntypedFormControl(null),
      ip_statisch: new UntypedFormControl(null),
      ip_dhcp: new UntypedFormControl(null),
      ip_dhcp_reservierung: new UntypedFormControl(null),
      ip_adresse: new UntypedFormControl(null),
      subnetzmaske: new UntypedFormControl(null),
      gateway: new UntypedFormControl(null),
      dns1: new UntypedFormControl(null),
      dns2: new UntypedFormControl(null),
      standort: new UntypedFormControl(null),
      ktostamm_standort: new UntypedFormControl(null),
      betriebssystem: new UntypedFormControl(null),
      lizenzkey: new UntypedFormControl(null),
      teamviewerid: new UntypedFormControl(null),
      teamviewer_passwort: new UntypedFormControl(null),
      lieferdatum: new UntypedFormControl(null),
      garantietyp: new UntypedFormControl(null),
      supporttyp: new UntypedFormControl(null),
      supportbis: new UntypedFormControl(null),
      ausscheidedatum: new UntypedFormControl(null),
    });
  }
}
